export default __webpack_public_path__ + "static/media/solutionBackground.32f2f92a.png";